import React from 'react';
import { Box, Card, CardContent, Typography, Zoom } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { StatCardProps } from './types';

const StatCard: React.FC<StatCardProps> = ({ title, value, icon, trend, color }) => (
  <Zoom in timeout={800}>
    <Card
      sx={{
        height: '100%',
        borderRadius: '18px',
        background: `linear-gradient(145deg, ${color}20, ${color}05)`,
        boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
        border: `1px solid ${color}30`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
        '&:hover': {
          transform: 'translateY(-4px) scale(1.01)',
          boxShadow: '0 22px 55px rgba(15, 23, 42, 0.25)',
        },
      }}
    >
      <CardContent sx={{ p: { xs: 2.25, md: 2.75 } }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 1.5,
          }}
        >
          <Box>
            <Typography
              variant="caption"
              sx={{ textTransform: 'uppercase', letterSpacing: 0.8, color: 'text.secondary' }}
            >
              {title}
            </Typography>
            <Typography
              variant="h5"
              component="div"
              sx={{ mt: 0.75, fontWeight: 600, wordBreak: 'break-word' }}
            >
              {value}
            </Typography>
          </Box>
          <Box
            sx={{
              p: 1.25,
              borderRadius: '14px',
              backgroundColor: `${color}25`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {icon}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          {trend > 0 ? (
            <TrendingUpIcon fontSize="small" color="success" sx={{ mr: 0.75 }} />
          ) : (
            <TrendingDownIcon fontSize="small" color="error" sx={{ mr: 0.75 }} />
          )}
          <Typography
            variant="body2"
            sx={{ fontSize: 12, color: trend > 0 ? 'success.main' : 'error.main' }}
          >
            {Math.abs(trend)}% from last period
          </Typography>
        </Box>
      </CardContent>
    </Card>
  </Zoom>
);

export default StatCard;
